
import * as msalBrowser from "@azure/msal-browser";
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router';
import { ReactComponent as LoginSvg } from './assets/icons/login.svg';
import { HeaderNav } from './components/feature/headerNav/headerNav';
import { MyPages } from './components/feature/myPages/myPages';
import { QuickPages } from './components/feature/quickPages/quickPages';
import { Settings } from './components/feature/settings/settings';
import { WorkRequests } from './components/feature/workRequests/workRequests';
import { DepartmentNav } from './components/shared/department/departmentNav';
import { AppContextProvider } from './contexts/appData';
import { requestPermission } from './firebase';
import { css } from './utils/css';
import { useIsMobile } from './utils/hooks';
import { ExposeForAndroid } from './components/shared/android/exposeForAndroid';

import styles from './App.module.css';


export const App = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const isMobile = useIsMobile();

    useEffect(() => {
        if (isMobile && location.pathname !== '/mypages' && location.pathname !== '/') {
            navigate('/mypages');
        }
    }, [isMobile]);

    const msal = useMsal();

    if (isMobile) {
        requestPermission();
    }


    function signOut() {
        msal.instance.logoutRedirect();
    }

    return (
        <MsalAuthenticationTemplate interactionType={msalBrowser.InteractionType.Redirect}>
            <AppContextProvider>
                <ExposeForAndroid />
                <div className={css(styles.App, isMobile && 'mobile')}>
                    {!isMobile && <nav>
                        <div className={css(styles.Lighter, styles.Login)}>
                            <LoginSvg onClick={signOut} />
                        </div>
                        <DepartmentNav />
                    </nav>}
                    
                    <div className={styles.Content}>
                        <HeaderNav />
                        <main className={styles.ContentMain}>
                            <Routes>
                                <Route path='/departments/:department' element={<WorkRequests />} />
                                <Route path='/mypages' element={<MyPages />} />
                                <Route path='/quickpages' element={<QuickPages />} />
                                <Route path='/settings' element={<Settings />} />
                                <Route
                                    path='/'
                                    element={<Navigate to='/mypages' replace />}
                                />
                            </Routes>
                        </main>
                    </div>
                </div>
            </AppContextProvider>
        </MsalAuthenticationTemplate>
    );
}